import gql from 'graphql-tag'

import { serfChoices } from '@/const/shared'

/* eslint-disable graphql/template-strings */
export const BU_SERF_STATS = gql`
  fragment BusinessUnitSerfStats on BusinessUnitSerfStats {
    ${serfChoices.join('\n')}
  }
`
